import React, { useEffect, useState } from "react";
import FilterSelector from "../Components/FilterSelector";
import { AgCharts } from "ag-charts-react";

function LiquidRatio({ data }) {
  const [activeDuration, setActiveDuration] = useState("overall_summary");
  const [barGraph, setBarGraph] = useState([]);
  const [series, setSeries] = useState([]);
  const [recurrentIncome, setRecurrentIncome] = useState({
    score: 0,
    status: "",
  });
  function formatToIndianRupees(num) {
    // Convert the number to a string
    if (num === null || num === undefined) return "₹--";
    return num.toLocaleString("en-IN", {
      maximumFractionDigits: 0,
      style: "currency",
      currency: "INR",
    });
  }
  const [nonRecurrentIncome, setNonRecurrentIncome] = useState({
    score: 0,
    status: "",
  });
  const [totalIncome, setTotalIncome] = useState({
    score: 0,
    status: "",
  });
  const [options, setOptions] = useState({
    data: barGraph,
    series: series,
    legend: {
      item: {
        label: {
          fontSize: 11, // Change the legend font size

          fontWeight: "normal",
          color: "#637381", // Change the legend font color
        },
        marker: {
          size: 11, // Change the size of the color boxes
        },
      },
    },

    axes: [
      {
        type: "category",
        position: "bottom",
        gridLine: false,
        label: {
          fontSize: 9,
          fontWeight: "light",
        },
      },
      {
        type: "number",
        position: "left",
        label: {
          fontWeight: "normal",
          fontSize: 11,
          formatter: (params) => {
            // Format with thousand separators and add a currency symbol
            return `${formatToIndianRupees(params.value)}`;
          },
        },
        gridLine: false,
      },
    ],

    height: 340,
  });

  function indianNumberFormat(num) {
    if (num >= 1e7) {
      num = num / 1e7;
      return `${num.toFixed(2)} Cr`;
    } else if (num >= 1e5) {
      num = num / 1e5;
      return `${num.toFixed(3)} L`;
    } else if (num >= 1e3) {
      num = num / 1e3;
      return `${num.toFixed(2)} K`;
    }
    return num.toFixed(2).toString();
    // return num.toString();
  }

  const mapDataBarGraph = (legend, recurrent, nonRecurrent, debt) => {
    const array = legend.map((item, index) => {
      return {
        quarter: item,
        recurrent_income: recurrent[index],
        non_recurrent_income: nonRecurrent[index],
        debt: debt[index],
      };
    });

    return array;
  };

  const mapSeries = () => {
    const array = [];
    array.push({
      type: "bar",
      xKey: "quarter",
      yKey: "non_recurrent_income",
      yName: "Non-Recurent Income",
      cornerRadius: 10,
      fill: "#26aba4",
      stacked: true,
    });
    array.push({
      type: "bar",
      xKey: "quarter",
      yKey: "recurrent_income",
      yName: "Recurent Income",
      cornerRadius: 10,
      fill: "#9d53f2",
      stacked: true,
    });

    array.push({
      type: "line",
      xKey: "quarter",
      yKey: "debt",
      yName: "Debt (Monthly)",
      stroke: "#0070d2",
      strokeWidth: 2,
      lineDash: [6, 3],
      marker: { enabled: false },
    });

    return array;
  };
  useEffect(() => {
    setBarGraph(
      mapDataBarGraph(
        data
          ? data[activeDuration]["debt_to_income_%"]?.income_recurrent["x-axis"]
          : [],

        data
          ? data[activeDuration]["debt_to_income_%"]?.income_recurrent["y-axis"]
          : [],
        data
          ? data[activeDuration]["debt_to_income_%"]?.income_non_recurrent[
              "y-axis"
            ]
          : [],
        data
          ? data[activeDuration]["debt_to_income_%"]?.debt_paid_map["y-axis"]
          : []
      )
    );
    setSeries(mapSeries());
    if (data) {
      setRecurrentIncome({
        score:
          data[activeDuration]["debt_to_income_%"]?.debt_paid_to_rec_income,
        status:
          data[activeDuration]["debt_to_income_%"]?.debt_paid_rec_income_remark,
      });
      setNonRecurrentIncome({
        score:
          data[activeDuration]["debt_to_income_%"]?.debt_paid_to_non_rec_income,
        status:
          data[activeDuration]["debt_to_income_%"]
            ?.debt_paid_non_rec_income_remark,
      });
      setTotalIncome({
        score: data[activeDuration]["debt_to_income_%"]?.debt_paid_to_income,
        status:
          data[activeDuration]["debt_to_income_%"]?.debt_paid_income_remark,
      });
    }
  }, [activeDuration, data]);
  useEffect(() => {
    setOptions({ ...options, data: barGraph, series: series });
  }, [barGraph, series]);
  return (
    <div className=" w-[49.5%] border border-[#e6ebed] rounded-lg ">
      <div className=" rounded-t-lg bg-[#f3f3f3] py-3 px-4 text-[#212b36] font-bold">
        <p>Debt-to-Income Ratio</p>
      </div>
      <FilterSelector
        activeDuration={activeDuration}
        setActiveDuration={setActiveDuration}
      />
      <div className=" mt-6 mb-2 flex w-full px-[15.75px] justify-between ">
        <CardComponent
          title={"Debt to Recurrent Income"}
          score={recurrentIncome.score}
          remark={recurrentIncome.status}
        />
        <CardComponent
          title={"Debt to Non-Recurrent Income"}
          score={nonRecurrentIncome.score}
          remark={nonRecurrentIncome.status}
        />
        <CardComponent
          title={"Debt to Total Income"}
          score={totalIncome.score}
          remark={totalIncome.status}
        />
      </div>
      <div className=" overflow-x-auto mt-[56px] ">
        <p className="text-[#212b36] text-xs font-bold ml-[15.75px]">
          Income Categorization
        </p>
        <div className="mt-1 ">
          <AgCharts options={options} />{" "}
        </div>
      </div>
    </div>
  );
}

export default LiquidRatio;

const CardComponent = ({ score, remark, title }) => {
  const getColor = (remark) => {
    if (remark === null || remark === undefined) {
      return "f7a452";
    }
    switch (remark) {
      case "Critical":
      case "Low":
        return "#00960f";
      case "Medium":
        return "#f7a452";
      case "High":
        return "#d30d00";
      default:
        return "#f7a452";
    }
  };
  return (
    <div
      style={{
        borderColor: getColor(remark),
      }}
      className={` min-w-[140px] w-[31%] border rounded  p-2 flex flex-col `}
    >
      <p className=" h-8 text-xs mx-auto text-center text-[#637381] font-semibold">
        {title}
      </p>
      <p className=" text-[32px] font-bold text-center mt-[6px]">{score}%</p>
      <p className=" text-xs font-medium text-[#262626] mt-[6px] text-center">
        Debt-to-Income Ratio is{" "}
        <span
          style={{
            color: getColor(remark),
          }}
          className={` font-bold `}
        >
          {remark || ""}
        </span>{" "}
      </p>
    </div>
  );
};
